import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, Wallet } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.info('Under development - Login functionality coming soon!');
  };

  const handleWalletConnect = () => {
    toast.info('Under development - Wallet connection coming soon!');
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20" style={{ background: 'var(--bg-primary)' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center justify-center">
            <img src="/logo.png" alt="MatrixLaunch Logo" className="h-16 w-auto object-contain" />
          </Link>
          <h1 className="text-3xl font-semibold mt-8 mb-2" style={{ color: 'var(--text-primary)' }}>Welcome Back</h1>
          <p style={{ color: 'var(--text-muted)' }}>Login to your account to continue</p>
        </div>

        {/* Login Form */}
        <div className="bg-white/5 border border-white/25 backdrop-blur-xl rounded-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: 'var(--text-primary)' }}>Email Address</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: 'var(--text-muted)' }} size={18} />
                <Input
                  type="email"
                  placeholder="your@email.com"
                  className="pl-12 bg-white/5 text-white placeholder:text-white/40 h-14"
                  style={{ 
                    borderColor: 'var(--border-subtle)',
                    color: 'var(--text-primary)'
                  }}
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: 'var(--text-primary)' }}>Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: 'var(--text-muted)' }} size={18} />
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  className="pl-12 pr-12 bg-white/5 text-white placeholder:text-white/40 h-14"
                  style={{ 
                    borderColor: 'var(--border-subtle)',
                    color: 'var(--text-primary)'
                  }}
                  value={formData.password}
                  onChange={(e) => setFormData({...formData, password: e.target.value})}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 transition-colors"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" className="w-4 h-4 rounded border-white/25 bg-white/5" />
                <span className="text-sm" style={{ color: 'var(--text-muted)' }}>Remember me</span>
              </label>
              <a href="#" className="text-brand-primary text-sm hover:underline">Forgot Password?</a>
            </div>

            <Button type="submit" className="btn-primary w-full">
              Login to Dashboard
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t" style={{ borderColor: 'var(--border-subtle)' }}></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4" style={{ background: 'var(--bg-primary)', color: 'var(--text-muted)' }}>Or continue with</span>
            </div>
          </div>

          {/* Wallet Connect */}
          <Button 
            className="btn-secondary w-full flex items-center justify-center gap-2"
            onClick={handleWalletConnect}
          >
            <Wallet size={18} />
            Connect Wallet
          </Button>

          {/* Signup Link */}
          <p className="text-center text-sm mt-6" style={{ color: 'var(--text-muted)' }}>
            Don't have an account?{' '}
            <Link to="/signup" className="text-brand-primary hover:underline font-medium">
              Sign Up
            </Link>
          </p>
        </div>

        {/* Security Notice */}
        <div className="mt-6 text-center">
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            Protected by advanced encryption and blockchain security
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
